import { TranslationMessages } from '../types';
import { app } from './app/it';
import { settingsApp } from './app/it';

const it: TranslationMessages = {
  nav: {
    howItWorks: 'Come funziona',
    why: 'Perché?',
    features: 'Funzionalità',
    getStarted: 'INIZIA',
    dashboard: 'Dashboard',
    blog: 'Blog',
  },
  hero: {
    title1: 'Telegram Stars',
    title2: 'Ricevi pagamenti facilmente',
    subtitle: 'Crea link di pagamento istantaneamente, gestisci il saldo e preleva in TON. Commissione piattaforma 3%.',
    cta: 'Inizia',
    hairsim: 'Simula il tuo trapianto di capelli',
  },
  demo: {
    botName: 'Telegram Stars Bot',
    online: 'online',
    linkCreated: 'Link di pagamento creato.',
    invoiceTitle: 'Premium Access',
    invoiceDesc: 'Abbonamento mensile',
    stars: 'Stars',
    payBtn: 'Paga 100 Stars',
    iPayNow: 'Pago adesso',
    paymentLabel: 'Pagamento Telegram Stars',
    merchant: 'Commerciante',
    amount: 'Importo',
    confirmPay: 'Conferma pagamento',
    paymentReceived: 'Pagamento ricevuto — 100 Stars',
    invoiceCredited: 'Invoice #xk9m2 · accreditato al saldo',
    thanks: 'Grazie, accesso attivato',
    messagePlaceholder: 'Messaggio',
  },
  stats: {
    title: 'Scelto da migliaia di agenti',
    subtitle: 'Unisciti a una community in crescita di commercianti che utilizzano i pagamenti Telegram Stars',
    activeAgents: 'Agenti attivi',
    transactions: 'Transazioni',
    uptime: 'Disponibilità',
    support: 'Supporto',
  },
  features: {
    title: 'Tutto ciò che serve per accettare pagamenti Telegram Stars',
    subtitle: 'Una piattaforma completa per gestire i tuoi pagamenti Telegram Stars',
    instantTitle: 'Creazione istantanea',
    instantDesc: 'Diventa agente in pochi secondi. Nessuna configurazione richiesta.',
    balanceTitle: 'Gestione del saldo',
    balanceDesc: 'Monitora i ricavi in tempo reale con una dashboard intuitiva.',
    paymentsTitle: 'Pagamenti Telegram Stars',
    paymentsDesc: 'Accetta pagamenti in Telegram Stars tramite il tuo bot.',
    securityTitle: 'Massima sicurezza',
    securityDesc: 'Registro immutabile, transazioni sicure e trasparenti.',
    withdrawTitle: 'Prelievi TON',
    withdrawDesc: 'Preleva i fondi direttamente sul tuo indirizzo TON.',
    apiTitle: 'API robusta',
    apiDesc: 'Integrazione semplice con webhook e API REST completa.',
  },
  how: {
    title: 'Come funziona',
    subtitle: 'Inizia in 3 semplici passaggi',
    startDemo: 'Avvia demo',
    demoRunning: 'Demo in corso...',
    reset: 'Reimposta',
    step1Title: '1. Registrati',
    email: 'Email',
    password: 'Password',
    noCard: '✓ Nessuna carta di credito richiesta',
    step2Title: '2. Crea link di pagamento',
    amountStars: 'Importo (Stars)',
    generatedLink: 'Link generato:',
    shareLink: '✓ Condividi questo link con i tuoi clienti',
    step3Title: '3. Preleva i fondi',
    tonAddress: 'Indirizzo TON',
    availableBalance: 'Saldo disponibile:',
    fee: 'Commissione: 3%',
  },
  pricing: {
    title: 'Prezzi semplici e trasparenti',
    subtitle: 'Nessun costo nascosto, nessun vincolo',
    commission: 'Commissione',
    perTransaction: 'per transazione',
    freeAccount: 'Creazione account gratuita',
    noMonthly: 'Nessun costo mensile',
    tonWithdrawals: 'Prelievi TON integrati',
    completeDashboard: 'Dashboard completa',
    support247: 'Supporto 24/7',
    startNow: 'Inizia ora',
  },
  faq: {
    title: 'Domande frequenti',
    subtitle: 'Tutto quello che devi sapere sui pagamenti Telegram Stars',
    q1: 'Come funziona il pagamento Telegram Stars?',
    a1: 'Il pagamento Telegram Stars consente ai commercianti di accettare pagamenti direttamente tramite Telegram. Gli utenti creano link di pagamento, li condividono con i clienti e ricevono pagamenti nella valuta Telegram Stars.',
    q2: 'Qual è la commissione della piattaforma?',
    a2: 'La commissione della piattaforma è del 3% per transazione. Copre l\'elaborazione dei pagamenti, la gestione del registro e la manutenzione della piattaforma. Non ci sono costi di attivazione o mensili.',
    q3: 'Come prelevo i miei Telegram Stars?',
    a3: 'Puoi richiedere prelievi sul tuo wallet TON. I prelievi vengono elaborati manualmente per sicurezza. Il prelievo minimo è di 100 Stars.',
    q4: 'Il pagamento Telegram Stars è sicuro?',
    a4: 'Sì, tutti i pagamenti vengono elaborati tramite il sistema di pagamento sicuro di Telegram. Utilizziamo crittografia e pratiche di sicurezza standard del settore.',
    q5: 'Cosa sono i Telegram Stars?',
    a5: 'Telegram Stars è una valuta virtuale utilizzata all\'interno di Telegram per i pagamenti. Gli utenti possono acquistare Stars e usarli per pagare servizi, prodotti e abbonamenti.',
    q6: 'Posso usare i pagamenti Telegram Stars per la mia attività?',
    a6: 'Sì! Telegram Stars Payment Platform è pensata per commercianti, creator e aziende. Puoi accettare pagamenti per prodotti digitali, servizi, abbonamenti e altro.',
  },
  cta: {
    title: 'Pronto a iniziare?',
    subtitle: 'Unisciti a migliaia di agenti che già utilizzano la nostra piattaforma',
    createAccount: 'Crea account gratuito',
    signIn: 'Accedi',
  },
  footer: {
    description: 'Piattaforma SaaS completa per pagamenti Telegram Stars',
    product: 'Prodotto',
    features: 'Funzionalità',
    pricing: 'Prezzi',
    support: 'Supporto',
    signIn: 'Accedi',
    docs: 'Documentazione',
    copyright: '© 2024 Telegram Stars Payment Platform. Tutti i diritti riservati.',
  },
  seo: {
    title: 'Telegram Stars Payment Platform | Accetta pagamenti via Telegram Stars',
    description: 'Accetta pagamenti via Telegram Stars. Crea link di pagamento istantaneamente, gestisci il saldo e preleva in TON. Commissione piattaforma 3%. Inizia ad accettare pagamenti Telegram Stars oggi.',
    keywords: 'pagamento telegram stars, accettare telegram stars, telegram stars payment platform, gateway pagamenti telegram stars',
  },
  whyPage: {
    seoTitle: 'Perché scegliere Telegram Stars Payment Platform | Vantaggi',
    seoDescription: 'Scopri perché commercianti e creator scelgono Telegram Stars Payment Platform: configurazione istantanea, prezzi trasparenti, pagamenti sicuri e portata globale.',
    title: 'Perché sceglierci?',
    subtitle: 'Pensato per commercianti e creator che vogliono pagamenti Telegram Stars semplici',
    r1Title: 'Configurazione istantanea',
    r1Desc: 'Inizia in pochi secondi. Nessuna configurazione complessa o conoscenza tecnica richiesta.',
    r2Title: 'Prezzi trasparenti',
    r2Desc: 'Solo il 3% per transazione. Nessun costo nascosto, nessun costo mensile, nessun costo di attivazione.',
    r3Title: 'Sicuro e affidabile',
    r3Desc: 'Basato sull\'infrastruttura di pagamento sicura di Telegram con crittografia standard del settore.',
    r4Title: 'Portata globale',
    r4Desc: 'Accetta pagamenti da utenti Telegram in tutto il mondo. Nessuna restrizione geografica.',
    r5Title: 'Integrazione semplice',
    r5Desc: 'API semplice e webhook. Integrati con i tuoi sistemi esistenti in pochi minuti.',
    r6Title: 'Prelievi TON',
    r6Desc: 'Preleva direttamente sul tuo wallet TON. Prelievi rapidi e sicuri.',
  },
  howPage: {
    seoTitle: 'Come funziona | Telegram Stars Payment Platform',
    seoDescription: 'Scopri come accettare pagamenti via Telegram Stars in 3 semplici passaggi. Crea il tuo account, genera link di pagamento e preleva in TON.',
    title: 'Come funziona',
    subtitle: 'Accetta pagamenti Telegram Stars in tre semplici passaggi',
  },
  settings: {
    title: "Impostazioni",
    languageSection: "Lingua",
    defaultLanguage: "Lingua predefinita",
    languageHint: "Questa lingua si applica a tutta la piattaforma (landing e interfaccia).",
    languageSaved: "Lingua aggiornata",
    ...settingsApp,
  },
  app,
};

export default it;
